import { ActivatedRoute, Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { RouterService } from 'src/app/services/router/router.service';

@Component({
  selector: 'app-request-received',
  templateUrl: './request-received.page.html',
  styleUrls: ['./request-received.page.scss'],
})
export class RequestReceivedPage implements OnInit {
 id 
 status = 'OK'
  constructor(public languageService: LanguagesService, private route: ActivatedRoute,private router : RouterService) { }

  ngOnInit() {
      this.id = this.route.snapshot.paramMap.get('id')
      this.status = this.route.snapshot.paramMap.get('status')
      console.log(this.languageService.language);
  }


  get getTextsIUPagepaymentRequest() {
    console.log(this.languageService.textsIU);
    
    return this.languageService.textsIU.page_payment_request_received;
  }
  goToRouter(router){
    this.router.redirectRoot(router)

  }
}
